import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type UpdateDayMutationVariables = Types.Exact<{
  dayId: Types.Scalars['ID'];
  date?: Types.InputMaybe<Types.Scalars['Date']>;
  vacation?: Types.InputMaybe<Types.Scalars['Boolean']>;
  totalHoursOff?: Types.InputMaybe<Types.Scalars['Float']>;
}>;


export type UpdateDayMutation = { __typename?: 'Mutation', updateDay?: { __typename?: 'Day', documentId: string, date?: any | null, vacation?: boolean | null, isSick?: boolean | null, totalHoursOff?: number | null, punches: Array<{ __typename?: 'Punch', documentId: string, in?: any | null, out?: any | null, location: string } | null>, hoursOff: Array<{ __typename?: 'HoursOff', documentId: string, from?: any | null, to?: any | null } | null>, user?: { __typename?: 'UsersPermissionsUser', documentId: string } | null } | null };

export type SetVacationsMutationVariables = Types.Exact<{
  user: Types.Scalars['ID'];
  dates: Array<Types.InputMaybe<Types.Scalars['Date']>> | Types.InputMaybe<Types.Scalars['Date']>;
}>;


export type SetVacationsMutation = { __typename?: 'Mutation', setVacations?: { __typename?: 'DayEntityResponseCollection', nodes: Array<{ __typename?: 'Day', documentId: string, date?: any | null, vacation?: boolean | null }> } | null };

export type SetIsSickMutationVariables = Types.Exact<{
  user: Types.Scalars['ID'];
  date: Types.Scalars['Date'];
  isSick: Types.Scalars['Boolean'];
}>;


export type SetIsSickMutation = { __typename?: 'Mutation', setIsSick?: { __typename?: 'DayEntityResponse', data?: { __typename?: 'Day', documentId: string, date?: any | null, vacation?: boolean | null, totalHoursOff?: number | null, isSick?: boolean | null, punches: Array<{ __typename?: 'Punch', documentId: string } | null>, hoursOff: Array<{ __typename?: 'HoursOff', documentId: string } | null> } | null } | null };


export const UpdateDayDocument = `
    mutation UpdateDay($dayId: ID!, $date: Date, $vacation: Boolean, $totalHoursOff: Float) {
  updateDay(
    documentId: $dayId
    data: {date: $date, vacation: $vacation, totalHoursOff: $totalHoursOff}
  ) {
    documentId
    date
    vacation
    isSick
    totalHoursOff
    punches(pagination: {limit: -1}) {
      documentId
      in
      out
      location
    }
    hoursOff(pagination: {limit: -1}) {
      documentId
      from
      to
    }
    user {
      documentId
    }
  }
}
    `;
export const useUpdateDayMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateDayMutation, TError, UpdateDayMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateDayMutation, TError, UpdateDayMutationVariables, TContext>(
      ['UpdateDay'],
      (variables?: UpdateDayMutationVariables) => fetcher<UpdateDayMutation, UpdateDayMutationVariables>(client, UpdateDayDocument, variables, headers)(),
      options
    );
export const SetVacationsDocument = `
    mutation setVacations($user: ID!, $dates: [Date]!) {
  setVacations(user: $user, dates: $dates) {
    nodes {
      documentId
      date
      vacation
    }
  }
}
    `;
export const useSetVacationsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetVacationsMutation, TError, SetVacationsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetVacationsMutation, TError, SetVacationsMutationVariables, TContext>(
      ['setVacations'],
      (variables?: SetVacationsMutationVariables) => fetcher<SetVacationsMutation, SetVacationsMutationVariables>(client, SetVacationsDocument, variables, headers)(),
      options
    );
export const SetIsSickDocument = `
    mutation setIsSick($user: ID!, $date: Date!, $isSick: Boolean!) {
  setIsSick(user: $user, date: $date, isSick: $isSick) {
    data {
      documentId
      date
      vacation
      punches(pagination: {limit: -1}) {
        documentId
      }
      hoursOff(pagination: {limit: -1}) {
        documentId
      }
      totalHoursOff
      isSick
    }
  }
}
    `;
export const useSetIsSickMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetIsSickMutation, TError, SetIsSickMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetIsSickMutation, TError, SetIsSickMutationVariables, TContext>(
      ['setIsSick'],
      (variables?: SetIsSickMutationVariables) => fetcher<SetIsSickMutation, SetIsSickMutationVariables>(client, SetIsSickDocument, variables, headers)(),
      options
    );